import React, { useEffect, useState, useCallback } from "react";
import {
  Building2, Building, MapPin, Truck, PackageCheck, Layers,
  Shield, CreditCard, Lock, Sparkles, Users, Warehouse,
  ClipboardList, Globe, Settings, Key, FileCheck, ScrollText,
  Box
} from "lucide-react";
import API_BASE_URL from "../config";

const ALL_CARDS = [
  { title: "Department", page: "department", icon: Building2, color: "from-indigo-500 to-indigo-600", bgColor: "bg-indigo-50", textColor: "text-indigo-600" },
  { title: "Company", page: "companyPage", icon: Building, color: "from-blue-500 to-blue-600", bgColor: "bg-blue-50", textColor: "text-blue-600" },
  { title: "Location", page: "locationPage", icon: MapPin, color: "from-green-500 to-green-600", bgColor: "bg-green-50", textColor: "text-green-600" },
  { title: "Vendor", page: "vendorPage", icon: Truck, color: "from-orange-500 to-orange-600", bgColor: "bg-orange-50", textColor: "text-orange-600" },
  { title: "Shipping Information", page: "shippingInformation", icon: PackageCheck, color: "from-teal-500 to-teal-600", bgColor: "bg-teal-50", textColor: "text-teal-600" },
  { title: "Expense Type", page: "expenseTypePage", icon: Layers, color: "from-purple-500 to-purple-600", bgColor: "bg-purple-50", textColor: "text-purple-600" },
  { title: "User Level", page: "userLevelPage", icon: Shield, color: "from-red-500 to-red-600", bgColor: "bg-red-50", textColor: "text-red-600" },
  { title: "Payment Method", page: "PaymentMethodsPage", icon: CreditCard, color: "from-pink-500 to-pink-600", bgColor: "bg-pink-50", textColor: "text-pink-600" },
  { title: "Position Level Access", page: "PositionLevelAccess", icon: Lock, color: "from-cyan-500 to-cyan-600", bgColor: "bg-cyan-50", textColor: "text-cyan-600" },
  { title: "License page", page: "LicenseSelectionPage", icon: FileCheck, color: "from-emerald-500 to-emerald-600", bgColor: "bg-emerald-50", textColor: "text-emerald-600" },
  { title: "Approver Position", page: "ApproverPositionManagement", icon: ClipboardList, color: "from-yellow-500 to-yellow-600", bgColor: "bg-yellow-50", textColor: "text-yellow-600" },
  { title: "Website Under Maintenance", page: "Website", icon: Settings, color: "from-gray-500 to-gray-600", bgColor: "bg-gray-50", textColor: "text-gray-600" },
  { title: "Website Information", page: "WebsiteInformation", icon: Globe, color: "from-sky-500 to-sky-600", bgColor: "bg-sky-50", textColor: "text-sky-600" },
  { title: "Items Maintenance", page: "ItemMaintenance", icon: PackageCheck, color: "from-blue-500 to-blue-600", bgColor: "bg-blue-50", textColor: "text-blue-600" },
  { title: "Requestor Maintenance", page: "Requestor", icon: Users, color: "from-violet-500 to-violet-600", bgColor: "bg-violet-50", textColor: "text-violet-600" },
  { title: "Warehouse", page: "WarehousePage", icon: Warehouse, color: "from-amber-500 to-amber-600", bgColor: "bg-amber-50", textColor: "text-amber-600" },
  { title: "License", page: "LicenseManagement", icon: Key, color: "from-rose-500 to-rose-600", bgColor: "bg-rose-50", textColor: "text-rose-600" },
  { title: "Logs", page: "Logs", icon: ScrollText, color: "from-slate-500 to-slate-600", bgColor: "bg-slate-50", textColor: "text-slate-600" },
  { title: "Notification Config", page: "Notification", icon: ScrollText, color: "from-slate-500 to-slate-600", bgColor: "bg-slate-50", textColor: "text-slate-600" },
  { title: "Truck", page: "Truck", icon: Truck, color: "from-slate-500 to-slate-600", bgColor: "bg-slate-50", textColor: "text-slate-600" },
  { title: "Scrap Codes", page: "ScrapCodesPage", icon: Box, color: "from-slate-500 to-slate-600", bgColor: "bg-slate-50", textColor: "text-slate-600" },
  { title: "Customer Maintenances", page: "CustomerMaintenance", icon: Box, color: "from-slate-500 to-slate-600", bgColor: "bg-slate-50", textColor: "text-slate-600" },
  { title: "Marketing ITems Maintenances", page: "Marketing_Itemsmaintenance", icon: Box, color: "from-slate-500 to-slate-600", bgColor: "bg-slate-50", textColor: "text-slate-600" },
  { title: "Accounting SystemS ettings", page: "AccountingSystemSettings", icon: Box, color: "from-slate-500 to-slate-600", bgColor: "bg-slate-50", textColor: "text-slate-600" },


  
];

const SYSTEM_ADMIN_ROLES = ["system admin", "systemadmin", "system administrator", "admin"];

// ─── Helpers ──────────────────────────────────────────────────────────────────



const getStoredUser = () => {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

// ✅ FIX: Try all possible field names, always return as Number


// ─── Component ────────────────────────────────────────────────────────────────

export default function ReferenceCards({ setCurrentPage }) {
  const [visibleCards, setVisibleCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adminOverride, setAdminOverride] = useState(false);

  console.log("🚀 ReferenceCards component MOUNTED"); // ← dagdag mo ito

  const fetchAccess = useCallback(async () => {
    console.log("🔥 fetchAccess CALLED"); // ← at ito
    const user = getStoredUser();
    const userId = user?.id ?? user?.userId;  // ✅ support both
    if (!userId) {
      setVisibleCards([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);

      // Step 1: Fetch all access records
      const accessRes = await fetch(`${API_BASE_URL}api/Ref_Access_cards`);
      if (!accessRes.ok) throw new Error("Failed to fetch access cards");
      const accessData = await accessRes.json();
      console.log("📋 All Ref_Access_cards:", accessData);

      // Step 2: Find record matching logged-in user's id
      // Step 2 — gamitin userId variable
      const myRecord = accessData.find((a) => {
        if (!a.isActive) return false;
        try {
          const parsed = JSON.parse(a.role_Position);
          return Number(parsed.userId) === Number(userId); // ✅ userId variable
        } catch { return false; }
      });
      console.log("🔍 My Access Record:", myRecord || `❌ NONE FOUND for userId: ${userId}`);

      if (!myRecord) {
        setVisibleCards([]);
        return;
      }

      const { referenceCards: allowedIds = [] } = JSON.parse(myRecord.role_Position);
      console.log("✅ Allowed Card IDs:", allowedIds);

      // Step 3: Fetch master ReferenceCards list
      const cardsRes = await fetch(`${API_BASE_URL}api/ReferenceCards`);
      if (!cardsRes.ok) throw new Error("Failed to fetch reference cards");
      const cardsData = await cardsRes.json();
      console.log("📦 All ReferenceCards:", cardsData.map(c => ({ id: c.id, pageKey: c.pageKey })));

      // Step 4: Resolve allowed IDs → pageKeys
      const allowedPageKeys = new Set(
        cardsData
          .filter((c) => allowedIds.map(Number).includes(Number(c.id)))
          .map((c) => c.pageKey)
      );
      console.log("🗝️ Resolved pageKeys:", [...allowedPageKeys]);

      // Step 5: Filter ALL_CARDS
      const filtered = ALL_CARDS.filter((c) => allowedPageKeys.has(c.page));
      console.log("🃏 Visible Cards:", filtered.map((c) => c.title));

      setVisibleCards(filtered);

    } catch (err) {
      console.error("❌ ReferenceCards fetch error:", err);
      setVisibleCards([]);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { fetchAccess(); }, [fetchAccess]);

  // ─── Loading ──────────────────────────────────────────────────────────────
  if (loading) return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-4 bg-white/40 backdrop-blur-xl border border-white/60 p-8 rounded-3xl shadow-2xl">
        <div className="w-12 h-12 border-4 border-blue-300 border-t-blue-600 rounded-full animate-spin" />
        <p className="text-gray-700 font-semibold">Loading...</p>
      </div>
    </div>
  );

  // ─── No access ────────────────────────────────────────────────────────────
  if (visibleCards.length === 0) return (
    <div className="flex items-center justify-center min-h-screen p-8">
      <div className="bg-white rounded-3xl p-10 shadow-xl border border-gray-100 text-center max-w-md">
        <div className="p-4 bg-gray-100 rounded-2xl inline-block mb-4">
          <Lock className="text-gray-400" size={32} />
        </div>
        <h2 className="text-2xl font-black text-gray-700 mb-2">No Access</h2>
        <p className="text-gray-500 text-sm">
          You don't have access to any reference cards. Contact your administrator.
        </p>
      </div>
    </div>
  );

  // ─── Main render ──────────────────────────────────────────────────────────
  return (
    <div className="min-h-screen from-slate-50 via-blue-50 to-indigo-100 p-8">
      <div className="max-w-8xl mx-auto">

        {/* Header */}
        <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100 mb-8">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl shadow-lg">
              <Sparkles className="text-white" size={32} />
            </div>
            <div>
              <h1 className="text-4xl font-black bg-gradient-to-r from-blue-600 via-blue-600 to-blue-600 bg-clip-text text-transparent">
                Reference Management
              </h1>
              <p className="text-gray-500 text-sm mt-1">Manage all your reference data in one place</p>
            </div>

            {adminOverride && (
              <div className="ml-auto flex items-center gap-2 bg-gradient-to-r from-indigo-500 to-purple-600 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg">
                <Shield size={14} />
                System Admin — Full Access
              </div>
            )}
          </div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {visibleCards.map((card, index) => {
            const IconComponent = card.icon;
            return (
              <button
                key={index}
                onClick={() => setCurrentPage(card.page)}
                className="group relative bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 overflow-hidden"
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${card.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`} />
                <div className={`absolute -top-8 -right-8 w-32 h-32 rounded-full bg-gradient-to-br ${card.color} opacity-10 group-hover:opacity-20 transition-all duration-300 group-hover:scale-150`} />

                <div className="relative z-10 flex flex-col items-center gap-5">
                  <div className={`p-5 rounded-2xl bg-gradient-to-br ${card.color} shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`}>
                    <IconComponent className="text-white" size={32} />
                  </div>
                  <div className="text-center">
                    <h2 className="text-xl font-bold text-gray-800 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:bg-clip-text transition-all duration-300"
                      style={{ backgroundImage: `linear-gradient(to right, var(--tw-gradient-stops))` }}>
                      {card.title}
                    </h2>
                    <p className="text-xs text-gray-500 mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      Click to manage
                    </p>
                  </div>
                  <div className={`px-4 py-1.5 rounded-full ${card.bgColor} opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0`}>
                    <span className={`text-xs font-bold ${card.textColor}`}>View Details →</span>
                  </div>
                </div>

                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
                </div>
              </button>
            );
          })}
        </div>

        {/* Stats Footer */}
        <div className="mt-8 bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg">
                <Layers className="text-white" size={20} />
              </div>
              <div>
                <p className="text-sm text-gray-500">Accessible References</p>
                <p className="text-2xl font-black text-gray-800">{visibleCards.length}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-500">Quick Access</p>
              <p className="text-sm font-bold text-indigo-600">Click any card to get started</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}